<template>
    <div class="field" style="margin-top: 0;">
        <label>{{ label }}</label>

        <div class="image__wrapper" v-if="imageName">
<!--            <img :src="imagePath + '' + imageName" id="image">-->
            <ImageRender
										:id="'image'"
										:src="imagePath + '' + imageName"
						>
						</ImageRender>
        </div>

        <div class="upload_image_field" style="">
            <svg style="margin-right: 15px;" width="18.000000" height="18.000000" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <defs/>
                <path id="Vector 6" d="M9.79553 12.6377C9.57581 12.8684 9.31067 12.9836 9 12.9836Q8.78577 12.9836 8.60034 12.9104Q8.38245 12.8245 8.20447 12.6377C7.98486 12.4075 7.875 12.1292 7.875 11.8032L7.875 3.90405L5.27905 6.46826C5.05237 6.69116 4.78357 6.79736 4.47314 6.78662C4.16248 6.77588 3.901 6.65137 3.68872 6.41382C3.4762 6.17578 3.375 5.8938 3.38513 5.56787C3.39526 5.24194 3.51379 4.96777 3.7406 4.74487L8.2406 0.318604C8.26306 0.295166 8.28564 0.280273 8.30811 0.262451C8.33691 0.236572 8.36694 0.211914 8.39807 0.188721C8.43005 0.168213 8.46289 0.149902 8.49658 0.132812C8.52747 0.118164 8.55566 0.0856934 8.58655 0.0856934C8.62622 0.0703125 8.6665 0.0576172 8.70752 0.0473633L8.79175 0.020752C8.8606 0.00683594 8.92993 0 9 0C9.07275 -0.000488281 9.14502 0.00634766 9.21655 0.020752L9.3009 0.0473633C9.34192 0.0576172 9.3822 0.0703125 9.42188 0.0856934C9.45276 0.0974121 9.48096 0.11499 9.51184 0.132812C9.54565 0.149902 9.57837 0.168457 9.61035 0.188721C9.64148 0.211914 9.67151 0.236572 9.70044 0.262451C9.72278 0.283203 9.74524 0.297852 9.76782 0.318604L14.2678 4.74487C14.4945 4.96777 14.613 5.24194 14.6232 5.56787C14.6334 5.8938 14.5323 6.17578 14.3198 6.41382C14.1074 6.65137 13.8459 6.77588 13.5354 6.78662C13.2249 6.79736 12.9562 6.69116 12.7292 6.46826L10.125 3.90405L10.125 11.8032C10.125 12.1292 10.0151 12.4075 9.79553 12.6377ZM16.2638 17.7756C15.9192 17.925 15.5605 18 15.1875 18L2.8125 18C2.43945 18 2.08081 17.925 1.73621 17.7756C1.39172 17.6257 1.08752 17.4124 0.82373 17.1357C0.560059 16.8591 0.356812 16.5398 0.214111 16.1785C0.0714111 15.8169 0 15.4404 0 15.0491L0 12.6885C0 12.3625 0.109863 12.0842 0.329468 11.854C0.549194 11.6235 0.814331 11.5083 1.125 11.5083Q1.33923 11.5083 1.52478 11.5813Q1.74255 11.6672 1.92053 11.854C2.14014 12.0842 2.25 12.3625 2.25 12.6885L2.25 15.0491C2.25 15.2124 2.30493 15.3511 2.41479 15.4666C2.52454 15.5818 2.65723 15.6394 2.8125 15.6394L15.1875 15.6394C15.3428 15.6394 15.4755 15.5818 15.5852 15.4666C15.6951 15.3511 15.75 15.2124 15.75 15.0491L15.75 12.6885C15.75 12.3625 15.8599 12.0842 16.0795 11.854C16.2992 11.6235 16.5643 11.5083 16.875 11.5083Q17.0892 11.5083 17.2748 11.5813Q17.4926 11.6672 17.6705 11.854C17.8901 12.0842 18 12.3625 18 12.6885L18 15.0491C18 15.4404 17.9286 15.8169 17.7859 16.1785C17.6432 16.5398 17.4399 16.8591 17.1763 17.1357C16.9125 17.4124 16.6083 17.6257 16.2638 17.7756Z" fill="#000000" fill-opacity="1.000000" fill-rule="evenodd"/>
            </svg>

            <input :disabled="isDataUpdating" type="file" accept="image/*" @change="setImage">
        </div>

        <div id="fileListLogo"></div>
        <p v-if="description" style="font-size: 13px; margin-top: 10px;">{{ description }}</p>

        <div style="margin-top: 15px;">
            <vue-cropper
                    ref="cropper"
                    :src="imgSrc"
                    alt="Source Image"
                    preview=".preview"
										:aspect-ratio="aspectRatio"
                    v-if="imgSrc != ''"
            >
            </vue-cropper>
        </div>

        <button class="button2" @click.prevent="cropImage()" v-if="imgSrc != ''">Сохранить
            изображение
        </button>
    </div>
</template>
<script setup>
import VueCropper from "vue-cropperjs";
import {defineProps, ref, toRefs, defineEmits } from 'vue'
import ImageRender from "@/components/Base/ImageRender.vue";
import ImageService from "@/services/ImageService";

const emit = defineEmits(['saveImage']);

const props = defineProps({
	label: {
    type: String
	},
  isDataUpdating: {
    type: Boolean
	},
	imagePath: {
    type: String
	},
	imageName: {
    type: String
	},
	entityId: {
    type: String
	},
  aspectRatio: {
    type: String
	},
	description: {
    type: String
	},
	minWidth: {
    type: Number
	}
})
const { isDataUpdating, imagePath, imageName, entityId, label, aspectRatio, description } = toRefs(props);

const cropper = ref(null);
let origfilename = ref('');
let imgSrc = ref('');

async function cropImage() {

  let crop = cropper.value;

  crop.getCroppedCanvas('getCroppedCanvas').toBlob(async function (blob) {
    let formData = new FormData();
    formData.append('file', blob);
    formData.append('original-name', origfilename.value);
    formData.append('entity-id', entityId.value);
    formData.append('current-name', imageName.value);

		emit('saveImage', formData)
    imgSrc.value = '';
  })
}

function setImage(e) {
  const file = e.target.files[0];
  if (!file.type.includes("image/")) {
    alert("Загрузить можно только изображение");
    return;
  }
  if (file.size > 5242880) {
    alert("Максимальный размер изображения 5 мегабайта. Обработайте изображение в графических редакторах, чтобы уменьшить его размер.");
    return;
  }
  origfilename.value = file.name;
  if (typeof FileReader === "function") {
    const reader = new FileReader();
    reader.onload = event => {
      imgSrc.value = event.target.result;
      if (cropper.value) {
        cropper.value.replace(event.target.result);
      }
    };
    reader.readAsDataURL(file);
  } else {
    alert("Sorry, FileReader API not supported");
  }
}
</script>

<style scoped>
.upload_image_field {
    display: flex;
		align-items: center;
    border-radius: 38px;
		padding: 7px 15px;
		border: 2px solid #F7C100;
		max-width: 190px;
		margin: 30px auto 0;
}
.upload_image_field svg {
		width: 50px;
}
.upload_image_field  input[type=file]::before {
    font-size: 16px;
    color: rgb(34, 34, 34);
}
</style>